import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import AppSidebar from './AppSidebar';
import AppTopbar from './AppTopbar';
import MENU_ITEMS from '../constants/menu';

import './AppShell.css';

function AppShell() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const { user } = useSelector((state) => ({ user: state.Auth.user }));
    const role = user?.role || '';

    const filteredMenu = MENU_ITEMS.filter((item) => item.role === role);

    return (
        <div className="lims-shell">
            <AppSidebar
                menuItems={filteredMenu}
                user={user}
                isOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
            />
            <div className="lims-right">
                <AppTopbar onMenuToggle={() => setSidebarOpen((o) => !o)} />
                <main className="lims-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}

export default AppShell;
